{
  "success": true,
  "loanId": "loan-mock-9988",
  "amountM": 10.0
}
